var _rect, _g, _rect2, _g2, _rect3, _rect4, _rect5, _g3, _rect6, _rect7, _g4, _rect8, _rect9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseIconApt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_498_10713)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_498_10713",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 21,
    height: 44
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.7783,
    width: 20,
    height: 44,
    fill: "#EEEEEE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_498_10713)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.7783,
    y: 1,
    width: 21.0526,
    height: 43.0222,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7783,
    y: 41,
    width: 20,
    height: 2.93333,
    fill: "#F46940"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7783,
    y: 34,
    width: 20,
    height: 10,
    fill: "#FB8F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7783,
    width: 20,
    height: 4,
    fill: "#F46940"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_498_10713)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_498_10713",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: 9,
    width: 21,
    height: 44
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -3.22168,
    y: 9,
    width: 20,
    height: 44,
    fill: "#EEEEEE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_498_10713)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.22168,
    y: 1,
    width: 21.0526,
    height: 43.0222,
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.22168,
    y: 34,
    width: 20,
    height: 10,
    fill: "#F46940"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.22168,
    y: 9,
    width: 20,
    height: 4,
    fill: "#F46940"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.77832,
    y: 19,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.77832,
    y: 25,
    width: 4,
    height: 4,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_498_10713)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_498_10713",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 9,
    width: 21,
    height: 44
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7783,
    y: 9,
    width: 20,
    height: 44,
    fill: "#EEEEEE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_498_10713)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.7783,
    y: 1,
    width: 21.0526,
    height: 43.0222,
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.7783,
    y: 34,
    width: 20,
    height: 10,
    fill: "#F46940"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.7783,
    y: 9,
    width: 20,
    height: 4,
    fill: "#F46940"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7783,
    y: 19,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7783,
    y: 25,
    width: 4,
    height: 4,
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.7783,
    y: 7,
    width: 4,
    height: 4,
    fill: "#090A0A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.7783,
    y: 7,
    width: 4,
    height: 4,
    fill: "#090A0A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7783,
    y: 13,
    width: 4,
    height: 4,
    fill: "#090A0A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.7783,
    y: 13,
    width: 4,
    height: 4,
    fill: "#090A0A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7783,
    y: 19,
    width: 4,
    height: 4,
    fill: "#090A0A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.7783,
    y: 19,
    width: 4,
    height: 4,
    fill: "#090A0A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7783,
    y: 25,
    width: 4,
    height: 4,
    fill: "#090A0A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.7783,
    y: 25,
    width: 4,
    height: 4,
    fill: "#090A0A"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7783,
    y: 36,
    width: 8,
    height: 8,
    fill: "#614E4E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7783,
    y: 34,
    width: 10,
    height: 2,
    fill: "#C0C0C0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_498_10713"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7783 0.999999C12.7783 0.447714 13.226 0 13.7783 0H31.7783C32.3306 0 32.7783 0.447715 32.7783 1V44H12.7783V0.999999Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_498_10713"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.77832 10C0.77832 9.44772 1.22604 9 1.77832 9H11.7783C12.3306 9 12.7783 9.44772 12.7783 10V44H0.77832V10Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_498_10713"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7783 10C32.7783 9.44772 33.226 9 33.7783 9H43.7783C44.3306 9 44.7783 9.44772 44.7783 10V44H32.7783V10Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIconApt);
export default __webpack_public_path__ + "static/media/houseIconApt.1d6e7b58e4f7da6ce3659d4a168d0edf.svg";
export { ForwardRef as ReactComponent };